import React from "react";
import { Row, Col, Image } from "react-bootstrap";
import Marquee from "react-fast-marquee";

import Icon1 from "../../../assets/empresas/1.png";
import Icon4 from "../../../assets/empresas/4.png";
import Icon5 from "../../../assets/empresas/5.png";
import Icon6 from "../../../assets/empresas/6.png";
import Icon7 from "../../../assets/empresas/7.png";
import Icon8 from "../../../assets/empresas/8.png";
import Icon9 from "../../../assets/empresas/9.png";
import Icon10 from "../../../assets/empresas/10.png";
import Icon1500Transp from "../../../assets/empresas/1500Transportes.png";
import IconAlfaTransportes from "../../../assets/empresas/AlfaTransportes.png";
import IconBorgno from "../../../assets/empresas/Borgno.png";
import IconCarvalho from "../../../assets/empresas/Carvalho.png";
import IconCoocatrans from "../../../assets/empresas/Coocatrans.png";
import IconFribon from "../../../assets/empresas/Fribon.png";
import IconG10 from "../../../assets/empresas/G10.png";
import IconFuturo from "../../../assets/empresas/Futuro.png";
import IconMotz from "../../../assets/empresas/Motz.png";
import IconMafro from "../../../assets/empresas/Mafro.png";
import IconRodofrota from "../../../assets/empresas/Rodofrota.png";
import IconRodoJunior from "../../../assets/empresas/Rodojunior.png";
import IconRodoLider from "../../../assets/empresas/Rodolider.png";
import IconSafraLog from "../../../assets/empresas/SafraLog.png";


export default () => {
      const arrayClientes = [
            { name: "Carvalho", image: IconCarvalho, height: "20%" },
            { name: "Rodofrota", image: IconRodofrota , height: "30%"},
            { name: "Coocatrans", image: IconCoocatrans,  height: '15%' },
            { name: "Borgno", image: IconBorgno , height: "40%"},
            { name: 'Jale Tansportes', image: Icon1 },
            { name: "Rodolider", image: IconRodoLider },
            { name: "1500 Transportes", image: Icon1500Transp,height: "35%" },
            { name: "Safra Log", image: IconSafraLog,  height: "15%" },
            { name: "Motz", image: IconMotz },
            { name: "Alfa Transportes", image: IconAlfaTransportes, height: "35%" },
            { name: "Mafro", image: IconMafro, height: "12%" },
            { name: 'Transpanorama', image: Icon4, height: '30%' },
            { name: 'Rodobelo', image: Icon5 },
            { name: "Futuro", image: IconFuturo , height: "45%"},
            { name: "Fribon", image: IconFribon, height: "8%"},
            { name: 'Belluno', image: Icon6 },
            { name: 'Brasil Central', image: Icon7 },
            { name: 'Cargo pag', image: Icon8 },
            { name: 'Everest', image: Icon9 },
            { name: "G10", image: IconG10 },
            { name: 'Pactus', image: Icon10 },
            { name: "Rodojunior", image: IconRodoJunior },
      ]
      return <>
            {/* EMPRESAS */}
            <Row id="part-empresas">
                  <Col md={12} className=" mt-2 mb-5">
                        <h2 className="text-center fw700 fGrey">
                              Veja quem confia no nosso trabalho
                        </h2>
                  </Col>
                  <Col md={12} id="container-empresas" className="mb-5">
                        <Marquee pauseOnHover gradient={false}>
                              {arrayClientes.map((cliente, idx) => <Image src={cliente.image} height={cliente?.height || '20%'} title={cliente.name} />)}
                        </Marquee>
                  </Col>
            </Row>
      </>
}